<script lang="ts">import ActionButton from "../ActionButton/ActionButton.svelte";
export let handleClick = (e) => {
    console.log('ProfilePhotoSaveButton: ');
};
</script>
  
  <ActionButton onClick={handleClick} title="Apply"/>